import { DesignDto } from "../generated/dashboard-client";
import { env } from "../env/env";
import { isTestEnv } from "../util/constants";


export function goToDesign(designId: string) {
  window.location.href = getDesignTimberLink(designId);
}

export function getDesignTimberLink(designId: string) {
  return `${env.timberContextPath}/design?id=${designId}`;
}

export function getDesign(designs: DesignDto[], designId: string) {
  return designs.find(it => it.id === designId) || null;
}

export function connectToPopmenu(fromReg: boolean, email: string) {
  let clientId = isTestEnv ? "sWCG2L1f3-Fxtj5wNB1RnzqiVmfJxIuNbCIwRYPlmEY" : "PcI1Z7XAqrOMc7rZFsizH0-H55dsmBrHuAYiOSDDiXQ";
  if (isTestEnv) {
    if (email.includes("sindhu")) {
      clientId = "x8uYwgwenjLIBIy1rCzM8Xh5NqwqcYlyDi_QPj1nG1Q";
    } else if (email.includes("ian")) {
      clientId = "L6S5mcVVTCGX35C0An7BumLYmtXjqrhiEFtLRKH_wrc";
    }
  }
  if (fromReg) {
    window.localStorage.setItem("popmenuFlowReg", "true");
  }
  const redirectUri = isTestEnv ? "https://test.mhmfun.com/home-test/popmenu" : "https://www.musthavemenus.com/home/popmenu";
  const scopes = "menus_read";
  window.location.href = `https://my.popmenu.com/oauth/authorize?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${scopes}`;
}
